<template>
    <div class="shop-product">
        <a
            class="shop-product__image-link"
            :href="`/${product.uri}`"
            v-on="{
                mouseenter: onMouseEnter,
                mouseleave: onMouseLeave,
            }"
        >
            <div class="relative shop-product__image__wrapper overflow-hidden flex items-center">
                <img
                    v-if="defaultImage"
                    class="shop-product__image lazyload"
                    :data-srcset="defaultImage.srcset"
                    :data-src="defaultImage.thumb"
                    :src="placeholder"
                    :alt="product.title"
                >

                <img
                    v-if="altImage"
                    class="shop-product__alt-image lazyload"
                    :class="{
                        'shop-product__alt-image--active': isActive,
                        'shop-product__alt-image--inactive': !isActive && isDirty
                    }"
                    :data-srcset="altImage.srcset"
                    :data-src="altImage.thumb"
                    :src="placeholder"
                    :alt="altImage.title"
                >
            </div>
        </a>

        <div v-if="tags" class="">
            <ul class="my-4 flex gap-2 flex-wrap">
                <li v-for="tag in tags" :key="tag.id" class="bg-secondary-900 text-white px-2 py-1 uppercase text-xs rounded-r-lg flex items-center gap-2"><span class="bg-white h-2 w-2 rounded-lg"></span> {{ tag.title }}</li>
            </ul>
        </div>

        <div class="flex items-start mt-4">
            <div class="">
                <a class="block flex-1" :href="`/${product.uri}`">
                    <p class="text-sm font-bold text-secondary-500">{{ title }}</p>
                    <div v-if="product.defaultVariant.pricePerM2 || product.defaultVariant.pricePerPiece" class="">
                        <p v-if="isMosaic && product.defaultVariant.pricePerPiece" class="text-sm font-bold text-black">from ${{ product.defaultVariant.pricePerPiece }} per piece</p>
                        <p v-else class="text-sm font-bold text-black">from ${{ product.defaultVariant.pricePerM2 }} m2</p>
                    </div>
                    <div v-else class="">
                        <p class="text-sm font-bold text-black">${{ product.defaultVariant.price }}</p>
                    </div>
                </a>
            </div>


            <button class="inline-flex items-center justify-center w-6 h-6 text-secondary-500" type="button" @click.prevent="toggleFavorite">
                <svg v-if="!wishlistLoading" class="w-4 h-4" viewBox="0 0 512 512">
                    <use :xlink:href="isFavorite ? '#icon-heart-solid' : '#icon-heart'" />
                </svg>

                <span v-else class="loading loading-sm"></span>
            </button>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { svgPlaceholder } from '../utils/svg';
const { mapState, mapGetters, mapActions } = createNamespacedHelpers('wishlist');

export default {
    props: {
        product: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            placeholder: svgPlaceholder(1, 1),
            wishlistLoading: false,

            isDirty: false,
            isActive: false,
        };
    },

    computed: {
        ...mapState({
            wishlistItems: (state) => { return state.items; },
        }),

        title() {
            let title = '';

            if (this.product.vendor && this.product.vendor.length > 0) {
                title = `${this.product.vendor[0].title} — `;
            }

            title += this.product.title;

            return title;
        },

        tags() {
            let tags = '';
            if (this.product.productTag && this.product.productTag.length > 0) {
                tags = this.product.productTag;
            }
            return tags;
        },

        defaultImage() {
            if (!this.product.defaultVariant) {
                return null;
            }

            const tileImage = this.product.defaultVariant.tileImage || this.product.tileImage;

            if (tileImage.length === 0) {
                return null;
            }

            return tileImage[0];
        },

        altImage() {
            if (!this.product.defaultVariant) {
                return null;
            }

            const additionalImages = this.product.defaultVariant.additionalImages || this.product.images;

            if (additionalImages.length === 0) {
                return null;
            }

            return additionalImages[0];
        },

        isFavorite() {
            return this.$store.getters['wishlist/isInWishlist'](this.product.id);
        },

        isMosaic() {
            let isMosaic = false;

            if (this.product.application && Array.isArray(this.product.application)) {
                this.product.application.forEach((item) => {
                    if (item.slug === 'mosaic') {
                        isMosaic = true;
                    }
                });
            }

            return isMosaic;
        },
    },

    methods: {
        ...mapActions([
            'toggleWishlist',
        ]),

        async toggleFavorite() {
            this.wishlistLoading = true;

            await this.toggleWishlist(this.product.id);

            this.wishlistLoading = false;
        },

        onMouseEnter() {
            this.isDirty = true;
            this.isActive = true;
        },

        onMouseLeave() {
            this.isActive = false;
        },
    },
};
</script>
